import React from 'react'
import { Button } from "@material-ui/core";

function FilterButton({filter}) {
  return (
      <Button 
          style={{
            borderRadius:'15px',
            height:'30px',
            marginRight:'30px',
            fontSize:"0.7em",
            fontWeight:'700',
            letterSpacing:'2px',
            marginBottom:'10px',
            boxShadow:'0px 9px 14px rgba(255, 255, 255, 0.2)',
            padding:'2px 4px'
          }} 
          variant="contained"
          size="medium">{filter}
      </Button>
  )
}

export default FilterButton
